import React, { useEffect } from 'react';
import { Tab } from 'semantic-ui-react';
import CardMCCustomerInsights from './CardMCCustomerInsights';
import CardMCAppointmentBehavior from './CardMCAppointmentBehavior';
import CardMCRevenueServicePerformance from './CardMCRevenueServicePerformance';
import CardMCUtilizationOperations from './CardMCUtilizationOperations';
import CardReportAgent from '../MEH/CardReportAgent';
import './styles/CardMeChart.scss';

type CardMeChartProps = {
  // Add props if needed
  controller: any,
  runSequence: any
  MeChartSequence: any;
  MeReportSequence?: any;
  productTypeOptions: any;
  packageTypeOptions: any;
  searchedItemListWithKey?: Record<string, any>;
  setProp?: any;
  errorMessage?: any;
  successMessage?: any;
  userProfile?: Record<string, any>;
}

// Main component for the "MeChart" dashboard.
// This component uses a Tab interface to display different categories of charts and insights.
const CardMeChart = (props: CardMeChartProps) => {

  useEffect(() => {
    props.runSequence({ sequence: "MeChart", restart: true });
    return () => {
      props.runSequence({ sequence: "MeChart", clear: true });
    };
  }, []);

  // Define the tabs and their corresponding content components
  const panes = [
    {
      menuItem: 'Customer Insights',
      // Tab 1: Customer Insights - Shows general customer demographics and data
      render: () => <Tab.Pane attached={false} basic>
        <CardMCCustomerInsights
          controller={props.controller}
          runSequence={props.runSequence}
          MeChartSequence={props.MeChartSequence} />
      </Tab.Pane>,
    },
    {
      menuItem: 'Appointment Behavior',
      // Tab 2: Appointment Behavior - Analyzes how customers make appointments
      render: () => <Tab.Pane attached={false} basic>
        <CardMCAppointmentBehavior
          controller={props.controller}
          runSequence={props.runSequence}
          MeChartSequence={props.MeChartSequence} />
      </Tab.Pane>,
    },
    {
      menuItem: 'Revenue & Service Performance',
      // Tab 3: Revenue & Service Performance - Tracks financial and service metrics
      render: () => <Tab.Pane attached={false} basic>
        <CardMCRevenueServicePerformance
          controller={props.controller}
          runSequence={props.runSequence}
          MeChartSequence={props.MeChartSequence}
          productTypeOptions={props.productTypeOptions}
          packageTypeOptions={props.packageTypeOptions}
          searchedItemListWithKey={props.searchedItemListWithKey}
        />
      </Tab.Pane>,
    },
    {
      menuItem: 'Utilization & Operations',
      // Tab 4: Utilization & Operations - Operational efficiency metrics
      render: () => <Tab.Pane attached={false} basic>
        <CardMCUtilizationOperations
          controller={props.controller}
          runSequence={props.runSequence}
          MeChartSequence={props.MeChartSequence} />
      </Tab.Pane>,
    },
    ...(props.userProfile?.is_staff
      ? [{
          menuItem: 'Data Intelligence Agent',
          render: () => <Tab.Pane attached={false} basic>
            <CardReportAgent
              runSequence={props.runSequence}
              setProp={props.setProp}
              MeReportSequence={props.MeReportSequence}
              errorMessage={props.errorMessage}
              successMessage={props.successMessage}
            />
          </Tab.Pane>,
        }]
      : []),
  ];

  return (
    <div id="card-me-chart">
      <h1>MeChart</h1>
      <Tab
        menu={{ secondary: true, pointing: true, style: { borderColor: 'var(--primary-theme-color)' } }}
        panes={panes}
        renderActiveOnly={true}
      />
    </div>
  );
}

export default CardMeChart;